const get = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const set = (key: string, value: string): void => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // sessionStorage may be unavailable (private mode, storage quota)
  }
};

export const sessionStorageUtils = { get, set };
